import { render, staticRenderFns } from "./EditClientStatus.vue?vue&type=template&id=312f61e0&"
import script from "./EditClientStatus.vue?vue&type=script&lang=js&"
export * from "./EditClientStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports